export default class MovementGenerator {
    // Public:
    constructor(cParams) {
        this.saveParams(cParams);
    }

    compute() {
        this._func = () => this.attachMovement();
        return this._func;
    }

    // Private:
    saveParams(cParams) {
        this._nodeFunc = cParams.nodeFunc;
        this._linkFunc = cParams.linkFunc;
        this._textVerticalPadding = cParams.textVerticalPadding;
        this._DEBUGGING_FUNCS = cParams.DEBUGGING_FUNCS;
    }

    attachMovement() {
        this.attachLinkMovementFunction();
        this.attachNodeMovementFunction();
        this.attachTextMovementFunction();
        this.DEBUGGING_ATTACH_MOVEMENT();
    }

    attachLinkMovementFunction() {
        this._linkFunc
            .attr("x1", d => d.source.x)
            .attr("y1", d => d.source.y)
            .attr("x2", d => d.target.x)
            .attr("y2", d => d.target.y);
    }

    attachNodeMovementFunction() {
        this._nodeFunc
            .selectAll("circle")
            .attr("cx", d => d.x)
            .attr("cy", d => d.y);
    }

    attachTextMovementFunction() {
        let verticalAlignerFunc = this.createTextVerticalAlignerFunction();
        this._nodeFunc
            .selectAll("text")
            .attr("x", d => d.x)
            .attr("y", verticalAlignerFunc);
    }

    createTextVerticalAlignerFunction() {
        let padding = this._textVerticalPadding;
        let f = d => d.y + d.radius + padding;
        return f;
    }

    DEBUGGING_ATTACH_MOVEMENT() {
        let funcs = this._DEBUGGING_FUNCS;
        for (let i = 0; i < funcs.length; i++) {
            const func = funcs[i];
            const radiusFunc = func.radiusFunc;
            func.selectAll("circle")
                .attr("cx", d => d.x)
                .attr("cy", d => d.y)
                .attr("r", radiusFunc);
        }
    }
}
